import { HttpClient, HttpParams } from "@angular/common/http";
import { lastValueFrom, map, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Records } from "../bo/records";
import { VibrationData } from "../bo/vibrationsForChart/vibration-data";
import { Injectable } from "@angular/core";
import { VibApiResponse } from "../bo/vib-api-response";
import { VibrationRecord } from "../bo/vibrationsForChart/vibration-record";
import { HttpService } from "./http.service";
import { ControlPoint } from "../bo/controlPoint";
import { VibrationRecords } from "../bo/vibrationsForChart/vibration-records";
import { AssignedRecords } from "../bo/vibrationsForChart/assigned-records";
import { VibrationRecordFilter } from "../bo/vibrationRecordFilter";
import { VibrationKpi } from "../bo/vibration-kpi";
import { StandardGraphDataDto } from "../bo/vibrationsForChart/standard-graph-data";
import { Standard } from "../bo/vibrationsForChart/standard";

@Injectable({
    providedIn: 'root'
  })
  export class VibrationsRecordService {
  
    private readonly baseUrl = environment.vibrationApiURL + '/api';
  
    constructor(private readonly httpClient: HttpClient,private readonly http: HttpService) { }
  
    public UploadFilenRecords(
      siteId: number,
      data: FormData
  
    ): Observable<any> {
      return this.httpClient.post(`${this.baseUrl}/sites/${siteId}/vibration-records/record-files`, data, {
        reportProgress: true,
        observe: 'events'
      });
    }
  
    public SaveRecords(
      siteId: number,
      recordsData: VibrationRecords
  
    ): Observable<VibApiResponse<boolean>> {
      return this.httpClient.post<VibApiResponse<boolean>>(`${this.baseUrl}/sites/${siteId}/vibration-records/record-data`, recordsData);
    }
  
      public GetRecords(
        siteId: number,
        controlPointId: number | null = null,
        blastId: number | null = null,
        device: string | null = null,
        pageNumber: number | null = null,
        pageSize: number | null = null,
        includeSignal: boolean,
        withCompanyFilter: boolean,
        forMultiAssign: boolean,
        startDate: string | null = null,
        endDate: string | null = null,
        note: string | null = null
      ): Observable<VibApiResponse<Records>> {
          const filter: VibrationRecordFilter = {
          siteId,
          eventId: null,
          blastId: blastId,
          controlPointId,
          device,
          pageNumber,
          pageSize,
          includeSignal,
          withCompanyFilter,
          forMultiAssign,
          controlPointsIds: null,
          eventsIds: null,
          startDate: startDate,
          endDate: endDate,
          note: note
        };
      return this.httpClient.put<VibApiResponse<Records>>(`${this.baseUrl}/sites/${siteId}/vibration-records`,  filter);
    }
  
    public GetRecordById(
      siteId: number,
      recordId: number,
      ponderationId?: number
    ): Observable<VibApiResponse<VibrationData>> {
  
      let params = new HttpParams();
      params = params.append('includeMetadata', true);
      params = params.append('includeSignal', true);
      if (ponderationId) {
        params = params.append('ponderationId', ponderationId);
      }
  
      return this.httpClient.get<VibApiResponse<VibrationData>>(`${this.baseUrl}/sites/${siteId}/vibration-records/${recordId}`, { params });
    }
  
    public updateRecord(
      siteId: number,
      recordId: string,
      recordData: VibrationRecord
    ): Observable<VibApiResponse<boolean>> {
      return this.httpClient.put<VibApiResponse<boolean>>(`${this.baseUrl}/sites/${siteId}/vibration-records/${recordId}`, recordData);
    }
  
  
    async deleteRecords(siteId: number, id: string): Promise<VibApiResponse<boolean>> {
        return await this.httpClient.delete<VibApiResponse<boolean>>(
          `${this.baseUrl}/sites/${siteId}/vibration-records/${id}`
        ).toPromise();
      }
      
    public loadControlPoints(siteId: number): Observable<ControlPoint[]> {
      return  this.http.get<ControlPoint[]>('Sites/' + siteId + '/ControlPoints', { transformCoord: true });
    }
    public assignRecords(
      siteId: number,
      recordsData: AssignedRecords
  
    ): Observable<VibApiResponse<boolean>> {
      return this.httpClient.post<VibApiResponse<boolean>>(`${this.baseUrl}/sites/${siteId}/vibration-records/assign`, recordsData);
    }
    public downloadFile(recordId: number): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/sftpgo/download/${recordId}`, { responseType: 'blob', observe: 'response' });
  }
  getDeviceNames(): Observable<any> {
    return this.httpClient
      .get<VibApiResponse<any>>(
        `${this.baseUrl}/Monitoring/devices-names`
      )
      .pipe(
        map(response => response.data)
      );
  }

  public saveManualRecord(siteId: number, payload: {
    controlPointId: number;
    distance: number;
    overpressure: number;
    pic: number;
    siteId: number;
    blastId?: number;
  }): Observable<VibApiResponse<boolean>> {
    return this.httpClient.post<VibApiResponse<boolean>>(
      `${this.baseUrl}/sites/${siteId}/vibration-records/minimal`,
      payload
    );
  }

    public getBlastKpi(siteId: number, blastId: number): Observable<VibApiResponse<VibrationKpi[]>> {
    return this.httpClient.get<VibApiResponse<VibrationKpi[]>>(
      `${this.baseUrl}/sites/${siteId}/vibration-records/kpi`,
      { params: { blastId } }
    );
  }
    getDownloadUrl(fileKey: string): Observable<{ downloadUrl: string }> {
    const params = [
      `fileKey=${encodeURIComponent(fileKey)}`
    ].join('&');
    return this.httpClient.get<{ downloadUrl: string }>(`${this.baseUrl}/Device/download-url?${params}`);
  }

    public getStandardGraphData(
    siteId: number,
    recordId: number,
    standardCode: string
  ): Observable<VibApiResponse<StandardGraphDataDto>> {
    const params = new HttpParams().set('standardCode', standardCode);
    return this.httpClient.get<VibApiResponse<StandardGraphDataDto>>(
      `${this.baseUrl}/sites/${siteId}/vibration-records/${recordId}/standard-graph`,
      { params }
    );
  }
    public getAllStandards(): Observable<VibApiResponse<Standard[]>> {
    return this.httpClient.get<VibApiResponse<Standard[]>>(`${this.baseUrl}/ponderation/standards`);
  }

    async deleteRecordsBulk(siteId: number, ids: number[]): Promise<VibApiResponse<number>> {
    return await lastValueFrom(this.httpClient.delete<VibApiResponse<number>>(
      `${this.baseUrl}/sites/${siteId}/vibration-records`,
      { body: ids }
    ));
  }

}
